import React from 'react';
import * as Styled from '../../Sizes.styles';
export default (function () {
  return /*#__PURE__*/React.createElement(Styled.ResponsiveWrapper, null, /*#__PURE__*/React.createElement(Styled.Table, null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "\xA0"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "UK"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "EU")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "Small"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "7-8"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "41-42")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "Medium"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "9-10"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "43-44")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "Large"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "11-12"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "45-47")))));
});